<template>
  <div>
    <!-- 操作日志对话框 -->
    <el-dialog
      :title="title"
      :visible="visible"
      width="60%"
      :modal-append-to-body="false"
      append-to-body
      @close="handleClose"
    >
      <div>
        <el-table :data="list" border>
          <template v-for="(item, index) in columnConfig">
            <el-table-column
              v-if="!!item.slot"
              :key="index"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <slot :name="item.slot" v-bind="scope"></slot>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="index"
              :prop="item.prop"
              :label="item.label"
            ></el-table-column>
          </template>
        </el-table>
      </div>
      <!-- //^ ^--------------分页组件-------------^ ^ -->
      <ElementPagination
        :current-page="searchParams.current"
        :page-size="searchParams.size"
        :total="searchParams.total"
        :page-sizes="[10, 20, 30, 40, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- 关闭按钮 -->
      <span v-if="closeBtn" slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleClose"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
export default {
  name: "WebSaaSOptionLog",
  components: {
    ElementPagination,
  },
  props: {
    /** 对话框标题 */
    title: {
      type: String,
      default: "日志",
    },
    /** 对话框显隐 */
    visible: {
      type: Boolean,
      default: false,
    },
    /** 列表配置 */
    columnConfig: {
      type: Array,
      default: () => [
        {
          prop: "operateTime",
          label: "操作时间",
        },
        {
          prop: "operator",
          label: "操作人",
        },
        {
          prop: "type",
          label: "操作类型",
          slot: "type",
        },
        {
          prop: "contentDiff",
          label: "修改内容",
          slot: "contentDiff",
        },
        {
          prop: "description",
          label: "审核意见",
        },
      ],
    },
    /** 分页配置 */
    searchParams: {
      type: Object,
      default: () => {
        return {
          current: 1,
          size: 10,
          total: 0,
        };
      },
    },
    /** 底部关闭按钮 */
    closeBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      list: [],
      subjectId: "",
    };
  },

  methods: {
    show(list, subjectId) {
      (this.subjectId = subjectId || ""), (this.list = list || []);
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    /** 关闭对话框 */
    handleClose() {
      this.visible = false;
      this.subjectId = "";
      this.list = [];
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.$emit("reload", this.subjectId);
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.$emit("reload", this.subjectId);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>